<template>
    <div class="mb-4">
        <booking-summary></booking-summary>
        <div class="mb-4">
            <current-action v-bind:action="'Guest names'"
                            v-bind:summary="'Let us know who\'s staying so we can get you booked in for your package extras'"></current-action>
        </div>
    </div>

    <Form @submit="onSubmit" :validation-schema="schema">
   
        <div class="container">
            <div class="row room-guest-names-wrapper">
                <div v-bind:key="room.leg"
                     v-for="(room, rIdx) in legGuests"
                     class="col-lg-24  col-xxl-12 mb-4">

                    <div class="rooom-guest-names bg-white has-shadow p-5">
                        <h3 class="mb-4">Room {{room.leg}} guests:</h3>
                        <Field :name="`legs[${rIdx}].leg`" type="hidden" :value="room.leg" />

                        <div class="row mb-3" v-if="isAuthenticated">
                            <div class="col-24">
                                <label class="staying-in-room">
                                    I am staying in this room
                                    <input style="margin-left: 20px"
                                           type="checkbox"
                                           v-on:click="setStayingGuest(rIdx)"
                                           v-model="stayingGuestIndex"
                                           v-bind:true-value="rIdx"
                                           false-value="-1" />
                                </label>
                            </div>
                        </div>


                        <div v-for="(guest, gIndex) in room.guests"
                             v-bind:key="gIndex"
                             class="form-group row mb-4">

                  
                            <div class="col-24">
                                <div class="room-guest-name-label">
                                    <span v-if="!guest.isChild">
                                        <span>Guest {{guest.guestCategoryIndex + 1}}</span>
                                    </span>
                                    <span v-if="guest.isChild">Child {{guest.guestCategoryIndex + 1}} ({{guest.age}} {{guest.age == 1 ? 'year' : 'years'}})</span>
                                </div>

                                <div class="row">
                                    <Field type="hidden" v-bind:value="guest.guestCategoryIndex" v-bind:name="`legs[${rIdx}].guests[${gIndex}].guestCategoryIndex`" />
                                    <Field type="hidden" v-bind:value="guest.isChild" v-bind:name="`legs[${rIdx}].guests[${gIndex}].isChild`" />
                                    <Field type="hidden" v-bind:value="guest.age" v-bind:name="`legs[${rIdx}].guests[${gIndex}].age`" />
                                    <Field type="hidden" v-model="guest.isLoggedInUser" v-bind:name="`legs[${rIdx}].guests[${gIndex}].isLoggedInUser`" />

                                    <div class="col-12 col-xl-6 mb-4 mb-xl-0">
                                        <Field v-if="!guest.isChild && !(stayingGuestIndex == rIdx && gIndex == 0)"
                                               v-bind:name="`legs[${rIdx}].guests[${gIndex}].title`" as="select" class="form-select" v-model="guest.title">
                                            <option disabled selected value="">Title</option>
                                            <option v-for="title in adultTitles" v-bind:key="title.OperaCode" v-bind:value="title.OperaCode" placeholder="Title">{{title.DisplayName}}</option>
                                        </Field>

                                        <Field readonly v-if="!guest.isChild && stayingGuestIndex == rIdx && gIndex == 0" v-bind:name="`legs[${rIdx}].guests[${gIndex}].title`" type="text" v-model="guest.title" class="form-control" />






                                        <Field v-if="guest.isChild" v-bind:name="`legs[${rIdx}].guests[${gIndex}].title`" as="select" class="form-select">
                                            <option disabled selected value="">Title</option>
                                            <option v-for="title in childTitles" v-bind:key="title.OperaCode" v-bind:value="title.OperaCode" placeholder="Title">{{title.DisplayName}}</option>
                                        </Field>

                                        <ErrorMessage v-bind:name="`legs[${rIdx}].guests[${gIndex}].title`" class="error-message" />
                                    </div>

                                    <div class="col-xl-9 mb-4 mb-xl-0">
                                        <Field v-bind:readonly="stayingGuestIndex == rIdx && gIndex == 0"
                                               v-bind:name="`legs[${rIdx}].guests[${gIndex}].firstName`"
                                               type="text" class="form-control" placeholder="First Name" v-model="guest.firstName" />
                                        <ErrorMessage v-bind:name="`legs[${rIdx}].guests[${gIndex}].firstName`" class="error-message" />
                                    </div>
                                    <div class="col-xl-9">
                                        <Field v-bind:readonly="stayingGuestIndex == rIdx && gIndex == 0"
                                               v-bind:name="`legs[${rIdx}].guests[${gIndex}].lastName`"
                                               type="text" class="form-control" placeholder="Last Name" v-model="guest.lastName" />
                                        <ErrorMessage v-bind:name="`legs[${rIdx}].guests[${gIndex}].lastName`" class="error-message" />
                                    </div>
                                </div>

                            </div>
                        </div>


                    </div>











                </div>
            </div>

        </div>




        <actions-bar>
            <template v-slot:actions>
                <div class="row">
                    <div class="col-12">

                        <button v-on:click="onBack"
                                type="button"
                                class="btn btn--transparent btn--back">
                            Back
                        </button>
                    </div>
                    <div class="col-12 d-flex justify-content-end">
                        <button class="btn btn--slate-blue btn--continue"
                                type="submit">
                            Next Step
                        </button>
                    </div>
                </div>
            </template>
        </actions-bar>

    </Form>
</template>

<script>


    import { Field, Form, ErrorMessage } from "vee-validate";
    import * as yup from "yup";

    import ActionsBar from '@/shared/components/ActionsBar.vue';
    import BookingSummary from '../components/BookingSummary.vue';
    import CurrentAction from '../components/CurrentAction.vue';

    import { store } from '../store/index';
    import { accountStore } from '@/account/store/index';


    export default {
        name: 'StayGuests',
        components: {
            ActionsBar,
            BookingSummary,
            CurrentAction,
            Field,
            Form,
            ErrorMessage
        },
        mounted() {
            this.legGuests = []
       
            for (let li in this.booking.legs) {
                let leg = this.booking.legs[li];
                let guests = leg.guests;

                this.legGuests.push({ leg: leg.leg, guests })
            }
        },
        computed: {
            session() {
                return store.getters.session
            },
            booking() {
                return store.getters.booking;
            },
            adultTitles() {
                return store.getters.roomConfiguration.AdultTitles;
            },

            childTitles() {
                return store.getters.roomConfiguration.ChildTitles;
            },
            isAuthenticated() {
                return accountStore.getters.isAuthenticated;
            },
            userProfile() {
                return accountStore.getters.userProfile;
            }
        },
        data() {
            let legGuests = [];

            const schema = yup.object().shape({
                legs: yup
                    .array()
                    .of(
                        yup.object().shape({
                            guests: yup
                                .array()
                                .of(yup.object().shape({
                                    guestCategoryIndex: yup.number(),
                                    isLoggedInUser: yup.boolean(),
                                    isChild: yup.boolean(),
                                    age: yup.number().notRequired(),
                                    title: yup.string().required().label("Title"),
                                    firstName: yup.string().required().label("First name"),
                                    lastName: yup.string().required().label("Last name"),
                                    stayingInRoom: yup.boolean().notRequired()
                                }))
                        })
                    )
                    .strict(),
            });

            return {
                stayingGuestIndex: null,
                legGuests,
                schema
            }
        },
        methods: {
            setStayingGuest(rIdx) {
                for (let ri = 0; ri < this.legGuests.length; ri++) {
                    var leg = this.legGuests[ri];
                    let guest = leg.guests[0];

                    if (ri == this.stayingGuestIndex) {
                        guest.isLoggedInUser = false;
                        guest.firstName = '';
                        guest.lastName = '';
                        guest.title = '';
                    }
                    
                }


                let guest = this.legGuests[rIdx].guests[0];
              
                guest.isLoggedInUser = true;
                guest.firstName = this.userProfile.FirstName;
                guest.lastName = this.userProfile.LastName;
                guest.title = this.userProfile.Title;
            

            },

            onGuestChange: (room, guests) => {
                room.guests = guests;
            },

            onSubmit: function (values) {

                let payload = values;
                store.dispatch("setGuests", payload).then(() => {
                    this.$router.push({ name: 'stay_itinerary', params: { id: this.session.Id } });
                });
            },
            onBack: function () {
                this.$router.push({ name: 'stay_leg_room_availability', params: { id: this.session.Id, leg: 1 } });

            }
        }
    }
</script>


<style src="@/shared/css/guests.css"></style>
<style>
    .staying-in-room {
        font-weight: bold;
        margin-bottom: 10px;
        font-size: 14px !important;
        cursor: pointer;
        margin-right: 20px;
    }

        .staying-in-room input[type=checkbox] {
            width: 20px;
            height: 20px;
            position: relative;
            top: 4px;
        }
</style>
